import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from '@material-ui/core'
import styled from 'styled-components'

const Radios = styled(RadioGroup)`
  padding-top: ${props => props.theme.spacing(2)}px;
  padding-left: ${props => props.theme.spacing(5)}px;
`

const ThemeTypeCard = props => {
  const { type, onChange } = props

  return (
    <Box p={4}>
      <FormControl component="fieldset">
        <Box ml={4}>
          <FormLabel component="legend">Type</FormLabel>
        </Box>
        <Radios aria-label="type" name="type" value={type} onChange={onChange}>
          <FormControlLabel value="light" control={<Radio />} label="Light" />
          <FormControlLabel value="dark" control={<Radio />} label="Dark" />
        </Radios>
      </FormControl>
    </Box>
  )
}

ThemeTypeCard.propTypes = {
  onChange: PropTypes.func,
  type: PropTypes.string,
}

export default ThemeTypeCard
